import { render } from "./examPointView.vue?vue&type=template&id=fb79f280"
import script from "./examPointView.vue?vue&type=script&lang=js"
export * from "./examPointView.vue?vue&type=script&lang=js"

import "./examPointView.vue?vue&type=style&index=0&id=fb79f280&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__